import { styled } from '@mui/material/styles';

import Logo from '../assets/images/logo/icon.webp';
import { useTheme } from '@mui/system';

// Loader style
const LoaderWrapper = styled('div')(({ theme }) => {
  return {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 2001,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '50%',

    border: '5px solid #ffff0030;',
    opacity: '85%;'
  };
});

// Keyframes for the outer glow animation
const glowKeyframes = `
  @keyframes glow {
    0% {
      transform: scale(1);
      box-shadow: 50px solid #ff380080;
     
     
     box-shadow: 0 0 5px 10px #ff830090;
    }
    50% {
      transform: scale(1.1);
     
      box-shadow: 0 0 5px 30px #ff830090;
    }
    100% {
      transform: scale(1);
   
      box-shadow: 0 0 5px 80px #ff830000;
    }
  }
`;

// Inject the keyframes into the component
const StyleInjector = styled('div')`
  ${glowKeyframes}
`;

// Styled Logo Component
// const StyledLogo = styled(Logo)(({ theme }) => ({
//   width: '100px',
//   height: '100px',
//   fill: theme.palette.primary.main,
//   animation: 'glow 2s linear infinite',
//   borderRadius: '60px'
// }));

// ==============================|| Loader ||============================== //

const Loader = () => {
  const theme = useTheme();
  return (
    <LoaderWrapper>
      <StyleInjector />
      <img
        src={Logo}
        alt="brand"
        style={{
          width: '100px',
          height: '100px',
          fill: theme.palette.primary.main,
          animation: 'glow 2s linear infinite',
          borderRadius: '60px'
        }}
      />
      {/* <StyledLogo /> */}
    </LoaderWrapper>
  );
};

export default Loader;
